import type { PermissionEnum } from 'fleet-data-model';
import { MeasurementSystem } from '@fleet-bffs/api-contract';
import type { ErrorType } from '~/data/ErrorRecord';
import type UserRoleConstants from '~/constants/user-role-constants';
import BusinessPartnerConstants from '~/constants/business-partner-constants';
import { LogoutStatus } from '~/domain/auth/models/LogoutStatus';

export const defaultState: Fields = {
  isAuthenticating: false,
  isFetchingUser: false,
  isUserInfoFetched: false,
  authenticated: false,
  logoutStatus: LogoutStatus.Idle,
  name: undefined,
  token: undefined,
  provider: undefined,
  expiresAt: undefined,
  refreshToken: undefined,
  error: undefined,
  landingPage: '/login',
  loginPage: '/login',
  logoLink: '/login',
  permissions: [],
  companyId: undefined,
  businessPartner: BusinessPartnerConstants.FOREST_AND_GARDEN,
  utcMarket: false,
};

export interface Fields {
  userId: string;
  isAuthenticating: boolean;
  isFetchingUser: boolean;
  isUserInfoFetched: boolean;
  authenticated: boolean;
  measurementSystem?: MeasurementSystem;
  logoutStatus: LogoutStatus;
  name?: string;
  firstName?: string;
  lastName?: string;
  registrationDate?: string;
  token?: string;
  provider?: string;
  expiresAt?: number;
  refreshToken?: string;
  error?: ErrorType;
  landingPage: string;
  diamGroupId: string;
  loginPage: string;
  logoLink: string;
  permissionTypes: UserRoleConstants[];
  permissions: PermissionEnum[];
  companyId?: string; // FIXME: Remove when the id is included in the JWT token and MongoDB can extract it
  companyName?: string;
  businessPartner: BusinessPartnerConstants;
  timeZone: string;
  utcMarket?: boolean;
}

export interface CurrentUserInfo {
  firstName?: string;
  lastName?: string;
  registrationDate?: string;
  provider?: string;
  loginPage: string;
  logoLink: string;
  name?: string;
  permissionTypes: UserRoleConstants[];
  permissions: PermissionEnum[];
  measurementSystem: MeasurementSystem;
  userId: string;
  landingPage: string;
  userCompany: {
    businessPartner: BusinessPartnerConstants;
    companyId: string;
    customerNumber: string;
    timeZone: string;
  };
  utcMarket?: boolean;
}

// export default class AuthenticationRecord extends Record<Fields>(defaultState) {}
